"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var pick_1 = __importDefault(require("lodash/pick"));
var react_final_form_1 = require("react-final-form");
var reactstrap_1 = require("reactstrap");
var ButtonSec_1 = require("components/Buttons/ButtonSec");
var RatingField_1 = __importDefault(require("components/Form/RatingField"));
var ButtonsHolder_1 = __importDefault(require("components/Inputs/Buttons/ButtonsHolder"));
var FormButton_1 = __importDefault(require("components/modules/form/FormButton"));
var RFTextField_1 = __importDefault(require("components/modules/form/RFTextField"));
var validators_1 = require("utils/form/validators");
var hooks_1 = require("utils/hooks");
var RecommendationContext_1 = require("./RecommendationContext");
var PREFIX = 'OptimiseFeedback';
var classes = {
    button: "".concat(PREFIX, "-button"),
    feedback: "".concat(PREFIX, "-feedback"),
};
var StyledCol = (0, styles_1.styled)(reactstrap_1.Col)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.button)] = {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2),
        },
        _b[".".concat(classes.feedback)] = {
            marginTop: theme.spacing(2),
        },
        _b);
});
var OptimiseFeedback = function (_a) {
    var onCancel = _a.onCancel, recommendation = _a.recommendation;
    var onClickCancel = function (form) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (onCancel)
                onCancel();
            form.reset();
            return [2 /*return*/];
        });
    }); }; };
    var _b = __read((0, hooks_1.useRecommendationSubmitter)(recommendation), 1), updateRecommendation = _b[0];
    var onSubmit = function (values) { return updateRecommendation(values, 'originalData'); };
    return ((0, jsx_runtime_1.jsx)(StyledCol, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit, initialValues: recommendation && (0, pick_1.default)(recommendation, ['reasonForRating', 'relevanceRating']), subscription: { submitting: true, values: true }, validate: (0, validators_1.requiredFields)(['relevanceRating']) }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit, submitting = _a.submitting, form = _a.form;
                return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit, noValidate: true }, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: RatingField_1.default, disabled: submitting, label: "Do you find this recommendation relevant?", name: "relevanceRating" }), (0, jsx_runtime_1.jsx)(react_final_form_1.FormSpy, __assign({ subscription: { dirty: true } }, { children: function (_a) {
                                var dirty = _a.dirty;
                                return !dirty
                                    ? null
                                    : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: RFTextField_1.default, disabled: submitting, className: "text-field-wrapper", label: "Please tell us why?", placeholder: "Reason for answer.", margin: "normal", name: "reasonForRating", required: true }), (0, jsx_runtime_1.jsxs)(ButtonsHolder_1.default, __assign({ className: "hover-show text-field-wrapper" }, { children: [(0, jsx_runtime_1.jsx)(ButtonSec_1.ButtonSecSm, __assign({ type: "button", className: classes.button, disabled: submitting, onClick: onClickCancel(form), color: "secondary" }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(FormButton_1.default, __assign({ className: classes.button, disabled: submitting, color: "secondary" }, { children: submitting ? 'In progress…' : 'Save & Close' }))] }))] }));
                            } })), (0, jsx_runtime_1.jsx)(react_final_form_1.FormSpy, __assign({ subscription: { submitError: true } }, { children: function (_a) {
                                var submitError = _a.submitError;
                                return submitError || null;
                            } }))] })));
            } })) }));
};
exports.default = (0, RecommendationContext_1.RecommendationHoC)(OptimiseFeedback);
